import { Component, Inject, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-landing-ntrip-caster',
  templateUrl: './landing-ntrip-caster.component.html',
  styleUrls: ['../landing/landing.component.scss', '../landing/headers.css', './landing-ntrip-caster.component.scss']
})
export class LandingNtripCasterComponent implements OnInit {

  lightboxOpen = false;
  lightboxSrc = '';
  lightboxAlt = '';

  constructor(private auth: AuthService, private router: Router, private title: Title, private meta: Meta, @Inject(DOCUMENT) private doc: Document) {}

  ngOnInit(): void {
    const CANON = 'https://geoastra.com';
    const url = `${CANON}/landing-ntrip-caster`;
    this.title.setTitle('GeoAstra NTRIP Caster — RTK Base to Internet CORS');
    this.meta.updateTag({ name: 'description', content: 'Transform your RTK Base into your own internet CORS service. Connect bases and rovers via GeoAstra NTRIP Caster with ease.' });
    this.meta.updateTag({ property: 'og:title', content: 'GeoAstra NTRIP Caster' });
    this.meta.updateTag({ property: 'og:description', content: 'RTK Base to Internet CORS. Connect bases and rovers via GeoAstra NTRIP Caster.' });
    this.meta.updateTag({ property: 'og:url', content: url });
    this.meta.updateTag({ property: 'og:type', content: 'website' });
    this.meta.updateTag({ property: 'og:image', content: 'https://geoastra.com/assets/images/landing/GeoAstra_NTRIP.png' });
    this.meta.updateTag({ name: 'twitter:card', content: 'summary_large_image' });
    this.meta.updateTag({ name: 'twitter:title', content: 'GeoAstra NTRIP Caster' });
    this.meta.updateTag({ name: 'twitter:description', content: 'RTK Base to Internet CORS. Connect bases and rovers via GeoAstra NTRIP Caster.' });
    this.meta.updateTag({ name: 'twitter:image', content: 'https://geoastra.com/assets/images/landing/GeoAstra_NTRIP.png' });
    // canonical (fixed to canonical host)
    let link: HTMLLinkElement | null = this.doc.querySelector("link[rel='canonical']");
    if (!link) {
      link = this.doc.createElement('link');
      link.setAttribute('rel', 'canonical');
      this.doc.head.appendChild(link);
    }
    link.setAttribute('href', url);
  }

  login(): void { this.auth.login(); }
  signup(): void { this.auth.signup(); }

  redirectToEnterPrise() {
    this.openExternal('https://gpswebshop.com/products/geoastra-ntrip-caster-enterprise-edition-12-month-subscription-service?variant=47996976169268');
  }

  redirectToPro() {
    this.openExternal('https://gpswebshop.com/products/geoastra-ntrip-caster-pro-edition-1-month-subscription-service?variant=47997022535988');
  }

  redirectToBasic() {
    this.openExternal('https://gpswebshop.com/products/geoastra-ntrip-caster-basic-edition-subscription-service');
  }

  goToWhatsNew(): void {
    this.router.navigate(['/landing-whats-new']);
  }

  goToQuickStart(): void {
    this.router.navigate(['/landing-quick-start']);
  }

  goToWhatsNewTop(): void {
    window.location.href = '/landing-whats-new';
  }

  goToQuickStartTop(): void {
    window.location.href = '/landing-quick-start';
  }

  goToWhatsNewAnchor(anchorId: string): void {
    window.location.href = `/landing-whats-new#${anchorId}`;
  }

  goToQuickStartAnchor(anchorId: string): void {
    window.location.href = `/landing-quick-start#${anchorId}`;
  }

  openLightbox(src: string, alt: string): void {
    this.lightboxSrc = src;
    this.lightboxAlt = alt;
    this.lightboxOpen = true;
  }

  closeLightbox(): void {
    this.lightboxOpen = false;
    this.lightboxSrc = '';
    this.lightboxAlt = '';
  }

  private openExternal(url: string): void {
    const win = window.open(url, '_blank', 'noopener');
    if (win) {
      win.opener = null;
    }
  }
}


